import styled from "styled-components";

export const SectionTitle = styled.h2`
  text-align: center;
  margin-bottom: 8px;
  line-height: 1;
  font-size: 36px;
  font-weight: bold;
  user-select: none;
`;

export const SectionSubtitle = styled.div`
  text-align: center;
  color: #1b2532;
  font-size: 16px;
  margin-bottom: 20px;
  line-height: 1;
  margin-top: 0;
  letter-spacing: 0.3em;
  user-select: none;
`;
